
<!--  eslint-disable -->
<template>
  <div class="petruth-group">
    <div id="div_block-234-16" class="ct-div-block search-box-bg">
      <div id="code_block-13-911" class="ct-code-block">

        <div class="search-wrapper">

          <div class="row">
            <div class="col-sm-3" v-if="categoryColumn">
              <label>Pitch Types</label><br>
              <b-form-select v-model="categorySelected" class="search-field-new">
                <option value="0">All Pitch Types</option>
                <option v-for="item in getCategories" :key="item.id" :value="item.id">
                  {{ item.name | capitalize }}
                </option>
              </b-form-select>
            </div>
            <div id="arrival_date_column2" :class="{ 'col-md-4': !categoryColumn, 'col-md-3': categoryColumn }">
              <label>Arrival Date</label><br>
              <datepicker wrapper-class="text-dark" input-class="search-field-new" v-model="from_date"
                format="dd/MM/yyyy" z-index="10000" />
            </div>
            <div id="length_of_stay_column2" :class="{ 'col-md-4': !categoryColumn, 'col-md-3': categoryColumn }">
              <label>Length Of Stay</label><br>
              <b-form-select v-model="days" style="width:100%;" class="search-field-new">
                <option value="1">1 night</option>
                <option :value="losLoop" v-for="(losLoop, index) in 28" v-if="index >= 1">
                  {{ losLoop }} nights
                </option>
              </b-form-select>
            </div>
            <div id="party_size_column2" :class="{ 'col-md-4': !categoryColumn, 'col-md-3': categoryColumn }">
              <label>Party Size</label><br>
              <b-form-select v-model="party" style="width:100%;" class="search-field-new">
                <option value="1">1 person</option>
                <option :value="dayLoop" v-for="(dayLoop, index) in 100" v-if="index >= 1">
                  {{ dayLoop }} persons
                </option>
              </b-form-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button class="ct-link-button search-button" @click="getSearchResults">
                <span v-show="!isLoading">CHECK AVAILABILITY</span>
                <span v-show="isLoading">
                  <b-spinner class="search-button-spinner" label="Loading... "></b-spinner>
                  Please wait..
                </span>
              </button>
            </div>
          </div>
          <div>

          </div>

        </div>

      </div>
    </div>

    <b-container v-if="!isLoading && displayResults" class="search-result-container p-5" v-bind="getCategories">
      <!-- {{ availabilityObject }} -->
      <!-- Show results -->

      <template>
        <b-row class="results-header">
          <div class="col-9 first">Pitch Types</div>
          <div class="d-none d-sm-block col-3 last">Available</div>
          <div class="d-block d-sm-none col-3 last">No.</div>
        </b-row>
        <b-row v-bind:key="item.id" v-for="item in searchResults" class="results-body">
          <div class="col-9 first">{{ item.unit_name }}</div>
          <div class="col-3 last">{{ item.level }}</div>
        </b-row>
      </template>

      <!-- Modal Component -->
      <b-modal id="modal1" v-model="modalShow" title="Choose an arrival date">
        <p class="my-4">{{ modalMessage }}</p>
      </b-modal>
    </b-container>
    <b-container>
      <div class="row" v-if="availabilityCheck">
        <div class="col">
          Unfortunately there is no availability for those dates please try again.
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import { setTimeout } from "timers";
import Datepicker from "vuejs-datepicker";
import { between, required } from "vuelidate/lib/validators";
// const _ = require("lodash");
export default {
  data() {
    return {
      minStay2: [
        69388,//American Bus
        33024,//Shepherds Hut (Peter Rabbit)
        7005, //.....Shepherds Hut..... (Jeremy Fisher)
        15786,//.....Shepherds Hut..... (Jemima Puddle-Duck)

        6783,   //Powered Bell Tents Parent
        15988, //Powered Bell Tents
        15989, //Powered Bell Tents
        15987, //Powered Bell Tents
        43234, //Powered Bell Tents

        31802, //Bell Tents
        31803, //Bell Tents
        36449, //Bell Tents
        15991, //Bell Tents

        43478,// Gypsy bowtop Frida
        43479,// Gypsy bowtop Ziggy
        43480 // Gypsy Bowtop Flo
      ],
      imageIterator: 1,
      checked: false,
      slide: 0,
      sliding: null,
      availabilityCheck: false,
      type: "number",
      from_date: moment().format("YYYY-MM-DD"),
      categorySelected: 0,
      units: [],
      categories: [],
      days: 1,
      categoryColumn: false,
      party: 1,
      searchResults: [],
      displayResults: false,
      noResults: false,
      isLoading: false,
      categoryInput: "",
      arrivalInput: "",
      modalShow: false,
      modalMessage: "Please select an arrival date",
      availabilityObject: [],
    };
  },
  validations: {
    categoryInput: {
      required,
      minLength: between(1, 10000),
    },
    daysInput: {
      between: between(1, 30),
    },
  },
  components: {
    Datepicker,
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
    }
  },
  computed: {
    getCategories() {
      return this.$store.getters.categories;
    }
  },
  methods: {

    getSearchResults() {
      this.isLoading = true;
      setTimeout(() => {
        // set the from and to date in moment
        let formattedFrom = moment(this.from_date).format("YYYY-MM-DD");
        let formattedTo = moment(this.from_date)
          .add(this.days, "days")
          // handles the departure date (which you don't want availability for)
          .subtract(1, "days")
          .format("YYYY-MM-DD");

        //TODO: this handles close match rate bands
        let ratesFormattedFrom = moment(this.from_date)
          .add(this.days, "days")
          .subtract(28, "days")
          .format("YYYY-MM-DD");
        // get availability by the dates set
        let availabilitiesResult = this.$store.getters.availability(
          formattedFrom,
          formattedTo,
          this.categorySelected
        );

        this.availabilityObject = availabilitiesResult;
        // get unit by the category set
        if (availabilitiesResult.length > 0) {
          // console.log(availabilitiesResult);
          // Getters
          let units = this.$store.getters.units(this.categorySelected);
          // console.log(units);
          let rates = this.$store.getters.rates(
            ratesFormattedFrom,
            formattedTo
          );
          // // TODO: pass in an array of amenity ids
          // let amenities = this.$store.getters.amenityFiltered(
          //   this.amenitySelected
          // );

          // init search results
          // the following resets the search results array to blank
          this.searchResults = [];
          //used in locally in this method which is then passed back to this.searchResults
          let thisSearchResults = [];

          // work out party size and party breakdown (adults + children)
          // assigned to variables as this does not work in nested loops
          let totalParty = parseInt(this.party, 10);
          let lengthOfStay = this.days;
          let unitPrice = this.calculatePrice;
          // console.log(units);
          if (this.days <= 1) {
            // const filtered = units.filter(unit => unit.id != 69388)
            const tempUnitArray = []
            this.minStay2.forEach(minStay => {
              units.forEach(unitItem => {
                if (minStay == unitItem.id) {
                  tempUnitArray.push(unitItem)
                }
              });
            });
            const unitstoDelete = new Set(tempUnitArray)
            const filtered = units.filter((unit) => {
              return !unitstoDelete.has(unit)
            })
            units = filtered
          }
          units.forEach((item1) => {
            // check for availability and only display if true
            let availabilityOK = true;
            let availabilityDays = [];
            let thisLevel = 0;
            let availabilityUnitId = 0;
            let unitId = item1.id;
            let availabilityKey = "";
            if (item1.parent_id == 0) {
              // if availability getter returns rows
              if (availabilitiesResult) {
                availabilitiesResult.forEach((item2) => {
                  // reassigns availabilityUnitId to the unit id in each item2
                  availabilityUnitId = item2.unit_id;
                  if (availabilityUnitId == unitId) {
                    // set the key of availabilityDays as
                    availabilityKey = moment(item2.day).format("YYYY-MM-DD");
                    // and then set the value of availabilityDays
                    availabilityDays[availabilityKey] = item2.level;
                    // console.log(availabilityDays);
                  }
                });
                // puts formattedFrom back to full date object
                let startDate = moment(formattedFrom);
                let tempDate = startDate.format("YYYY-MM-DD");
                for (let i = 0; i < lengthOfStay; i++) {
                  let thisDaysAvailability = availabilityDays[tempDate];
                  console.log(thisDaysAvailability)
                  if (typeof thisDaysAvailability == "undefined") {
                    availabilityOK = false;
                  } else {
                    // console.log("index position");
                    // console.log(i);
                    if (i == 0) {
                      thisLevel = parseInt(thisDaysAvailability);
                    } else if (parseInt(thisDaysAvailability, 10) === 0) {
                      availabilityOK = false;
                    }
                  }
                  tempDate = moment(tempDate)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  // console.log(tempDate);
                }
              } else {
                availabilityOK = false;
              }

              // if days in the range selected all have at least level 1 then move on to setting rates
              if (availabilityOK) {
                let searchResultItem = {};
                if (thisLevel != 0) {
                  searchResultItem = {
                    unit_name: item1.name,
                    level: thisLevel
                  };
                  thisSearchResults.push(searchResultItem);
                }
              }
            }
          });

          if (thisSearchResults.length > 0) {
            this.searchResults = thisSearchResults;
            this.availabilityCheck = false;
            this.displayResults = true;
          }

        } else {

          this.availabilityCheck = true;
          this.displayResults = false;
          console.log("no availability");
        }

        this.isLoading = false;
      }, 0);
    }
  },
};
</script>

<style lang="scss" scoped>
// ::v-deep .vdp-datepicker__calendar {
//   position: fixed;
// }

// .search-wrapper {
//   min-height: 560px;
// }
.search-button-spinner {
  width: 1.3rem;
  height: 1.3rem;
  border-width: 0.2em;
}

.search-button {
  width: 100%;
  margin: 10px 0 !important;
  background-color: #56BCB1;
  border-color: #56BCB1;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.search-button:hover {
  background: #0d3029 !important;
  border-color: #0d3029 !important;
}

.green-search-button {
  width: 100%;
  margin: 10px 0 !important;
  background-color: #7DB400;
  border-color: #7DB400;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.green-search-button:hover {
  background: #0d3029 !important;
  border-color: #0d3029 !important;
}

.search-result-container {
  width: 100%;
  margin-bottom: 60px;
  border: 3px solid black;
  border-radius: 22px;
}

.search-result-container .row:not(:last-child) {
  margin-bottom: 5px;
}

.search-result-container .row:last-child {
  margin-bottom: 0px;
}

.results-header {
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
  border-color: #EF8C33;
  border-style: solid;
  font-family: 'display-patrol';
  font-size: 18px;
  font-weight: 500;
  border-radius: 22px;
  overflow: hidden;
  color: #fff;

  .first {
    padding: 10px 20px;
    color: #EF8C33;
  }

  .last {
    padding: 10px 20px;
    background-color: #EF8C33;
    text-align: center;
  }
}

.results-body {
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
  background-color: #ffebe1;
  border-color: #008476;
  border-style: solid;
  font-family: 'display-patrol';
  font-size: 18px;
  font-weight: 500;
  border-radius: 22px;
  overflow: hidden;

  .first {
    padding: 10px 20px;
    background-color: #fff;
    color: black;
  }

  .last {
    padding: 10px 20px;
    background-color: #008476;
    text-align: center;
    color: #fff;

  }

}
</style>